<template>
  <div class="tabs">
    <a
      class="tabs__item"
      :class="{tabs__item_active:item.value===current}"
      v-for="(item,index) in tabs"
      :key="index"
      @click="$router.push(item.to)">
      {{ item.label }}
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    current: {
      type: String,
      default: 'ticket'
    }
  },
  computed: {
    ...mapState(['showMember']),
    tabs () {
      const data = [
        {
          label: '门票预订',
          value: 'ticket',
          to: '/ticket'
        },
        {
          label: '会员预订',
          value: 'member',
          to: '/member'
        }
      ]

      if (!this.showMember) {
        data.splice(1, 1)
      }
      return data
    }
  }
}
</script>

<style lang="less" scoped>
.tabs {
  position: relative; margin-top: 20px;
  &::after{
    content: ''; position: absolute; height: 1px; background: #ddd; width: 100%; left: 0;bottom: 0;
  }
}

.tabs__item {
  display: inline-block; padding: 10px 20px; margin-right: 3px; color: #666; background: #efefef; border-radius: 6px 6px 0 0; cursor: pointer; border: 1px solid #ddd; border-bottom: none; position: relative;
  &_active {
    color: #3a7fdf;  background: #fff; z-index: 3;
  }
}

</style>
